<!-- src/components/VueModal.vue -->

<template>
    <transition name="modal">
        <div class="fixed inset-0 z-[9999] overflow-y-auto">
          <div class="flex min-h-full justify-center items-start md:items-center">
            <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
            <div role="dialog" class="relative bg-white rounded-sm shadow-xl transform transition-all w-full container lg:max-w-screen-md">
              <div class="flex flex-row justify-between bg-gradient-to-r from-cal-009588 to-cal-71AF2F text-white p-4">
                <slot name="header"></slot>
                <button class="text-sm" v-if="allowClose" @click="close()">
                  <span class="icon icon-cancel"></span><span class="sr-only">Close</span>
                </button>
              </div>
              <div class="p-4">
                <div class="modal-body text-base text-black">
                  <slot name="body"></slot>
                </div>
                <div class="text-right mt-6">
                  <slot name="footer">
                    <button class="modal-default-button" @click="close()">Save</button>
                  </slot>
                </div>
              </div>
            </div>
          </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        size: String,
        allowClose: {
            default: true
        }
    },

    mounted () {
        document.body.classList.add('modal-open');
    },

    beforeDestroy () {
        document.body.classList.remove('modal-open');
    },

    methods: {
        close () {
            document.body.classList.remove('modal-open');
            this.$emit('close');
        }
    }
}
</script>
